"use client";

import styles from "./CategoryListSkeleton.module.css";

function NewsSkeleton() {
  return (
    <div className={styles.wrap} aria-hidden>
      <div className={styles.heroRow}>
        <div className={`${styles.sk} ${styles.heroMain}`} />
        <div className={`${styles.sk} ${styles.heroSide}`} />
      </div>
      <div className={styles.newsGrid}>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className={`${styles.sk} ${styles.newsCard}`} />
        ))}
      </div>
    </div>
  );
}

function PodcastSkeleton() {
  return (
    <div className={styles.wrap} aria-hidden>
      <div className={styles.podGrid}>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className={`${styles.sk} ${styles.podCard}`} />
        ))}
      </div>
    </div>
  );
}

export default function CategoryListSkeleton({ variant = "news" }) {
  if (variant === "podcast") return <PodcastSkeleton />;
  return <NewsSkeleton />;
}
